import { Pipe, PipeTransform } from '@angular/core';
/*
 Custom pipe to sort the array of object
 */
@Pipe({ name: 'sorted' })
export class SortedPipe implements PipeTransform {
  transform(value: any, exponent: any) {
    const data = value.sort((a, b) =>
      a.timeSlotDuration.localeCompare(b.timeSlotDuration)
    );
    return data;
  }
}
